import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "src/store";
import { expireTicket, setMaxTimeThunk, startTimer } from "src/store/slices/timer/timer.slice";

export default function useRestoreTimer(session?: { startedAt: number; maxTime: number }) {
  const dispatch = useDispatch<AppDispatch>();
  const isRunning = useSelector((state: RootState) => state.timer.isRunning);
  const isCancelled = useSelector((state: RootState) => state.timer.isCancelled);

  useEffect(() => {
    if (isRunning || isCancelled || !session) return;
    const remaining = session.startedAt + session.maxTime - Date.now();
    if (remaining <= 0) {
      dispatch(expireTicket());
    } else {
      dispatch(setMaxTimeThunk(remaining));
      dispatch(startTimer());
    }
  }, []);
}
